module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.f3dd4f3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.woff
// module id = sItb
// module chunks = 0